module.exports = "<span class=\"visions\">{{visionTag}}</span>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/vision/vision-label/vision-label.component.html
// module id = ./src/app/vision/vision-label/vision-label.component.html
// module chunks = main